<template>
  <svg
    id="vehicle"
    width="205"
    height="205"
    viewBox="0 0 205 205"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="1">
      <path
        id="wheels"
        d="M174 200H96C89.1107 199.979 82.5094 197.234 77.6379 192.362C72.7665 187.491 70.0206 180.889 70 174C70.0206 167.111 72.7665 160.509 77.6379 155.638C82.5094 150.766 89.1107 148.021 96 148H174C180.889 148.021 187.491 150.766 192.362 155.638C197.234 160.509 199.979 167.111 200 174C199.979 180.889 197.234 187.491 192.362 192.362C187.491 197.234 180.889 199.979 174 200Z"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        :style="wheels"
      />
      <path
        id="other"
        d="M102.5 170.75C103.362 170.75 104.189 171.092 104.798 171.702C105.408 172.311 105.75 173.138 105.75 174"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="other"
        d="M99.25 174C99.25 173.138 99.5924 172.311 100.202 171.702C100.811 171.092 101.638 170.75 102.5 170.75"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="other"
        d="M102.5 177.25C101.638 177.25 100.811 176.908 100.202 176.298C99.5924 175.689 99.25 174.862 99.25 174"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="other"
        d="M105.75 174C105.75 174.862 105.408 175.689 104.798 176.298C104.189 176.908 103.362 177.25 102.5 177.25"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="other"
        d="M135 170.75C135.862 170.75 136.689 171.092 137.298 171.702C137.908 172.311 138.25 173.138 138.25 174"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="other"
        d="M131.75 174C131.75 173.138 132.092 172.311 132.702 171.702C133.311 171.092 134.138 170.75 135 170.75"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="other"
        d="M135 177.25C134.138 177.25 133.311 176.908 132.702 176.298C132.092 175.689 131.75 174.862 131.75 174"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="other"
        d="M138.25 174C138.25 174.862 137.908 175.689 137.298 176.298C136.689 176.908 135.862 177.25 135 177.25"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="other"
        d="M167.5 170.75C168.362 170.75 169.189 171.092 169.798 171.702C170.408 172.311 170.75 173.138 170.75 174"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="other"
        d="M164.25 174C164.25 173.138 164.592 172.311 165.202 171.702C165.811 171.092 166.638 170.75 167.5 170.75"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="other"
        d="M167.5 177.25C166.638 177.25 165.811 176.908 165.202 176.298C164.592 175.689 164.25 174.862 164.25 174"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="other"
        d="M170.75 174C170.75 174.862 170.408 175.689 169.798 176.298C169.189 176.908 168.362 177.25 167.5 177.25"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="vehicleBody"
        d="M187 151.51V109C187 105.552 185.63 102.246 183.192 99.8076C180.754 97.3696 177.448 96 174 96H161C157.552 96 154.246 94.6304 151.808 92.1924C149.37 89.7544 148 86.4478 148 83V70C148 66.5522 146.63 63.2456 144.192 60.8076C141.754 58.3696 138.448 57 135 57H96C92.5522 57 89.2456 58.3696 86.8076 60.8076C84.3696 63.2456 83 66.5522 83 70V151.51"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        :style="body"
      />
      <path
        id="other"
        d="M109 83H122"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="vehicleHand"
        d="M82.9997 98.3651L9.54107 30.0718C6.94513 27.616 5.34618 24.2891 5.05035 20.7279C4.75451 17.1667 5.78259 13.6215 7.93774 10.7711V10.7711C10.0919 7.91724 13.2235 5.95875 16.7323 5.27106C20.2412 4.58336 23.8804 5.21484 26.9524 7.04446L112.752 56.8345"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        :style="hand"
      />
      <path
        id="vehicleAnchor"
        d="M44 128.5C44 132.357 42.8564 136.127 40.7137 139.334C38.571 142.54 35.5255 145.04 31.9623 146.516C28.3992 147.992 24.4784 148.378 20.6957 147.625C16.9131 146.873 13.4386 145.016 10.7114 142.289C7.9843 139.561 6.12711 136.087 5.3747 132.304C4.62228 128.522 5.00845 124.601 6.48436 121.038C7.96027 117.475 10.4596 114.429 13.6664 112.286C16.8731 110.144 20.6433 109 24.5 109"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        :style="anchor"
      />
      <path
        id="anchorLine"
        d="M24.5 108.998V44.2324"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        :style="line"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Vue } from "vue-facing-decorator";
import { Component } from "vue-facing-decorator";

@Component({})
export default class Vehicle extends Vue {
  public strokeWheels = 0;
  public strokeBody = 0;
  public strokeHand = 0;
  public strokeAnchor = 0;
  public strokeAnchorLine = 0;

  // 'stroke-dasharray': this.strokeWheels,
  get wheels() {
    return {
      "stroke-dashoffset": this.strokeWheels,
    };
  }

  get body() {
    return {
      "stroke-dasharray": this.strokeBody,
      "stroke-dashoffset": this.strokeBody,
    };
  }

  get hand() {
    return {
      "stroke-dasharray": this.strokeHand,
      "stroke-dashoffset": this.strokeHand,
    };
  }

  get anchor() {
    return {
      "stroke-dasharray": this.strokeAnchor,
      "stroke-dashoffset": this.strokeAnchor,
    };
  }

  get line() {
    return {
      "stroke-dasharray": this.strokeAnchorLine,
      "stroke-dashoffset": this.strokeAnchorLine,
    };
  }

  mounted() {
    this.$nextTick(() => {
      this.strokeWheels = (
        document.getElementById("wheels") as any
      ).getTotalLength();
      this.strokeBody = (
        document.getElementById("vehicleBody") as any
      ).getTotalLength();
      this.strokeHand = (
        document.getElementById("vehicleHand") as any
      ).getTotalLength();
      this.strokeAnchor = (
        document.getElementById("vehicleAnchor") as any
      ).getTotalLength();
      this.strokeAnchorLine = (
        document.getElementById("anchorLine") as any
      ).getTotalLength();
    });
  }
}
</script>

<style scoped>
#wheels {
  stroke-dasharray: 20px;
  animation:
    line-animation 4s reverse infinite 3s,
    line-animation-wheel 6s reverse forwards;
}

#vehicleBody {
  animation: line-animation-body 4s ease forwards 0.3s;
}
#vehicleHand {
  animation: line-animation 4s ease forwards 0.6s;
}

#vehicleAnchor {
  animation: line-animation 4s ease forwards 0.9s;
}

#anchorLine {
  animation: line-animation 4s ease forwards 1.2s;
}

#other {
  animation: other 2s ease forwards;
}

@keyframes line-animation {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes line-animation-body {
  to {
    stroke-dashoffset: 541.4022216796875;
  }
}

@keyframes line-animation-wheel {
  from {
    stroke-dasharray: 0px;
  }
  to {
    stroke-dasharray: 25px;
  }
}

@keyframes other {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
